import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid-pro'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { Pageview } from '@mui/icons-material'

function ViewRequestButton({ id }: GridRowParams) {
  const navigate = useNavigate()
  return (
    <GridActionsCellItem
      icon={<Pageview />}
      label="View Request"
      onClick={() => navigate(`/stuart/health/screen/${id}/collections`)}
    />
  )
}

export default ViewRequestButton
